import { ActionCreator } from 'react-redux'
import { Action } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { Url } from 'url'

import axiosVerbose from '../utils/axios/axiosVerbose'
import { logError } from '../utils/errors'
import getProxyApiUrl from '../utils/getProxyApiUrl'

import { ILoadDataOptions } from '../../typings/loadDataOptions'
import { ISearchResults } from '../../typings/searchResults'
import { ISeoMetadata } from '../../typings/seoMetadata'

import { IRootState } from '../../common/reducers'

export enum TypeKeys {
  GET_HOME_PAGE_API_SUCCESS = 'GET_HOME_PAGE_API_SUCCESS',
  GET_HOME_PAGE_API_FAIL = 'GET_HOME_PAGE_API_FAIL'
}

export interface IHomePageApiData {
  readonly metadata?: ISeoMetadata
  readonly newest_items?: ISearchResults
  readonly featured_items?: ISearchResults
}

export interface IGetHomePageApiSuccessAction {
  type: TypeKeys.GET_HOME_PAGE_API_SUCCESS
  payload: Readonly<IHomePageApiData>
}

export interface IGetHomePageApiFailAction {
  type: TypeKeys.GET_HOME_PAGE_API_FAIL
}

export type ActionTypes =
  | IGetHomePageApiSuccessAction
  | IGetHomePageApiFailAction

export const fetchHomePageDataBySite: ActionCreator<
  ThunkAction<Promise<ActionTypes>, IRootState, void>
> = (parsedUrl: Url, opts: ILoadDataOptions) => {
  return (dispatch, getState) => {
    const { currentSite } = getState().common

    const apiUrlPrefix = getProxyApiUrl(opts)

    return axiosVerbose
      .get(`${apiUrlPrefix}/shopfront_api/homepage/${currentSite}`)
      .then(response => {
        const action: IGetHomePageApiSuccessAction = {
          payload: response.data,
          type: TypeKeys.GET_HOME_PAGE_API_SUCCESS
        }
        return dispatch(action)
      })
      .catch(err => Promise.reject(logError(err)))
      .catch(() => {
        const action: IGetHomePageApiFailAction = {
          type: TypeKeys.GET_HOME_PAGE_API_FAIL
        }
        return dispatch(action)
      })
  }
}



// WEBPACK FOOTER //
// ./common/actions/homePage.ts